import Controller from '@ember/controller';
import { service } from '@ember/service';
import type { LinkManagerService } from 'ember-link';
import type { Tab } from 'walden-fast/components/tabs';
import type { AppWaldenViewModel } from 'walden-fast/routes/app/walden-view';

export default class AppWaldenViewController extends Controller {
  declare model: AppWaldenViewModel;

  detailRouteName = 'app.walden-view.detail';

  @service('link-manager') declare linkManager: LinkManagerService;

  get tabs(): Tab[] {
    if (this.model.pages) {
      return this.model.pages
        .map((page) => {
          const isExternal = !!page.externalUrl;

          if (page.routeName && !isExternal) {
            return {
              type: 'internal' as const,
              label: page.displayName,
              internalLink: this.linkManager.createLink({
                route: this.detailRouteName,
                models: [page.routeName],
              }),
            };
          }

          return {
            type: 'external' as const,
            label: page.displayName,
            externalLink: page.externalUrl || '',
          };
        })
        .filter(({ type }: { type: string }) => {
          return type === 'internal' || this.model?.showExternalLinks;
        });
    } else {
      return [];
    }
  }
}
